import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { environment } from '../Environment';

@Injectable({
  providedIn: 'root'
})
export class GetDeleteTimesheetService {

  apiUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      'Accept': '*/*'
    })
  };

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => errorMessage);
  }

  private readonly getTimesheetApi = this.apiUrl + 'GetDeleteTimeSheet/GetTimesheet';
  private readonly deleteTimesheetAPI = this.apiUrl + 'GetDeleteTimeSheet/DeleteTimeSheetDataById'

    GetTimeSheet(startWeek: any,endWeek: any): Observable<any> {
      const body = {
        StartWeek: startWeek,
        EndWeek: endWeek
      };
  
      return this.http
        .post(this.getTimesheetApi, body, this.httpOptions)
        .pipe(retry(1), catchError(this.handleError));
    }

    private getRandomAuthorizationKey(): string {
      const keys = environment.AuthorizationKeys;
      const randomIndex = Math.floor(Math.random() * keys.length);
      //alert(`Using Authorization Key: ${randomIndex}`);
      return keys[randomIndex];
    }
    deleteTimesheet(timeSheetReturnId: string) {
      const body = {
        TimeSheetReturnId: timeSheetReturnId,
        AuthorizationKey: this.getRandomAuthorizationKey()
      };
      return this.http.post(this.deleteTimesheetAPI,body);
    // return this.http.post(`${this.apiUrl}?TimeSheetReturnId=${timeSheetReturnId}&AuthorizationKey=${authorizationKey}`);
  }
}
